<template>
	<div class="flex flex-row justify-content-between align-items-center" style="border-radius: 100rem; width: 100%; background-color: var(--theme-color1);">
      <SvgModeLight class="cursor-pointer" className="thememode-svg" :color="theme.mode === 'light' ? 'var(--button-normal-color)' : 'var(--theme-color5)'" style="transition: all 0.3s;" :style="theme.mode === 'light' ? 'transform: scale(1.1)' : ''" @click="store.dispatch('theme/goToTheme', 'light')"/>
      <SvgModeAuto class="cursor-pointer" className="thememode-svg" :color="theme.mode === 'auto' ? 'var(--button-normal-color)' : 'var(--theme-color5)'" style="transition: all 0.3s;" :style="theme.mode === 'auto' ? 'transform: scale(1.1)' : ''" @click="store.dispatch('theme/goToTheme', 'auto')"/>
      <SvgModeDark class="cursor-pointer" className="thememode-svg" :color="theme.mode === 'dark' ? 'var(--button-normal-color)' : 'var(--theme-color5)'" style="transition: all 0.3s;" :style="theme.mode === 'dark' ? 'transform: scale(1.1)' : ''" @click="store.dispatch('theme/goToTheme', 'dark')"/>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { computed } from 'vue';
// vue
import SvgModeDark from '@/components/SVGs/SvgModeDark.vue';
import SvgModeAuto from '@/components/SVGs/SvgModeAuto.vue';
import SvgModeLight from '@/components/SVGs/SvgModeLight.vue';
// Others
import { useStore } from 'vuex';

const store = useStore()

// --- Theme info ---
const theme = computed(() => store.state.theme.theme)
</script>